import { useMutation } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import { Login as LoginIcon } from '@mui/icons-material'

import { useNotify, useRecordContext, Button } from '..'
import { useAuth } from '../../../hooks'
import { mutations } from '../../../graphql'

export function LoginAsButton({ userId, destination }) {
  const navigate = useNavigate()
  const [, { impersonate }] = useAuth()
  const notify = useNotify()

  const [loginAsMutation, { loading }] = useMutation(mutations.auth.loginAs)
  return (
    <Button
      onClick={async () => {
        try {
          const {
            data: {
              loginAs: { access_token: token },
            },
          } = await loginAsMutation({ variables: { userId } })
          navigate('/funds', { replace: true, state: { _impersonationTransition: true } })
          await impersonate(token)
          if (destination) {
            navigate(destination, { replace: true })
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
          notify('Error: failed to impersonate for some reason, please try again later', { type: 'warning' })
        }
      }}
      disabled={loading}
      label="Impersonate"
    >
      <LoginIcon />
    </Button>
  )
}
